import { TodoApiClient } from '@/clients/todoApiClient';
import type { TodoItem } from '@/types/todo';
import type { RedirectOptions } from '@/clients/todoApiClient';
import type { AnswerCardInput, AnswerCardResult } from '@/types/card';

export class TodoService {
  static async listTodos(companyId: string): Promise<TodoItem[]> {
    return TodoApiClient.listTodos(companyId);
  }

  static async listAllTodos(): Promise<TodoItem[]> {
    return TodoApiClient.listAllTodos();
  }

  static async redirectTodo(todoId: string, opts?: RedirectOptions): Promise<TodoItem> {
    return TodoApiClient.redirectTodo(todoId, opts);
  }

  static async redirectTodos(
    todoIds: string[],
    opts?: RedirectOptions,
  ): Promise<{ sentIds: string[]; failedIds: string[] }> {
    return TodoApiClient.redirectTodos(todoIds, opts);
  }

  static async answerCardTodo(input: AnswerCardInput): Promise<AnswerCardResult> {
    return TodoApiClient.answerCardTodo(input);
  }
}
